

import React, { useState, useEffect, useRef } from 'react';
import { apiRequest } from '../../fetchSetup';
import addressConfig from '../../Configurations/addressConfig.json';
import axios from 'axios';
import {
   Typography, Button, 
  Dialog, DialogContent, DialogActions,
  patch,
} from "@mui/material";

const POSMedicineSystem = () => {
  const [activeTab, setActiveTab] = useState('sale');
  const [medicines, setMedicines] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [cart, setCart] = useState([]);
  const [refresh,setRefresh] = useState(false);

  const [patientDetails, setPatientDetails] = useState({
    name: '',
    email: '',
    phone: '',
    age: '',
    gender: '',
    doctorname: '',
  });
  const [orderCreatePymentFailed,setOrderCreatePymentFailed]=useState(false);
  const [paymentMethod, setPaymentMethod] = useState('cash');
  const [discountType, setDiscountType] = useState('flat');
  const [discountValue, setDiscountValue] = useState(0);
  const [showPaymentDialog, setShowPaymentDialog] = useState(false);
  const [showUpiDialog, setShowUpiDialog] = useState(false);
  const [currentOrder, setCurrentOrder] = useState(null);
  const [upiTransactionId, setUpiTransactionId] = useState('');
  const [currentUser,setCurrentUser] = useState(null);
  const [razorpayLoaded, setRazorpayLoaded] = useState(false);

  const [orders, setOrders] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
  const [notification, setNotification] = useState(null);
  const [loading, setLoading] = useState(false);
  const [packDiscountPrice,setPackDiscountPrice]=useState(null)

  const [showOrderDetails, setShowOrderDetails] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  // Load initial data from props or sessionStorage
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
    const [loadingUserData, setLoadingUserData] = useState(false);
    const [userFound, setUserFound] = useState(false);
    
  const [qrCodeUrl, setQrCodeUrl] = useState(null);
  // ─── AYUJA Pricing State ──────────────────────────────────────────────────
  const [ayujaCartPrices, setAyujaCartPrices] = useState({});   // medicine_id → selling_price
  const [ayujaSummary, setAyujaSummary] = useState(null);
  const [offeredDiscountPct, setOfferedDiscountPct] = useState(null);
  const lastFetchedCartKey = useRef('');
  const pricingPollRef = useRef(null);

  const pricingFetchedRef = useRef(false); 
  const medicinesFetchedRef = useRef(false);
  const qrFetchedRef = useRef(false);

  const staffEmail = sessionStorage.getItem('email') || 'support@ayuja.life';
  const staffName = sessionStorage.getItem('staffName') || 'POS Staff';
  //const communities = addressConfig.communities || [];
  const [communities, setCommunities] = useState([]);
  const API_URL=process.env.REACT_APP_API

  // ─── AYUJA: fetch pricing config (poll every 10s) ─────────────────────────
  useEffect(() => {
    if (pricingFetchedRef.current) return;
    pricingFetchedRef.current = true;

    const POLL_EVERY = 10 * 1000;
    const CACHE_KEY = 'ayujaPricingConfig';

    const fetchPricingConfig = async (bustCache = false) => {
      if (!bustCache) {
        try {
          const raw = sessionStorage.getItem(CACHE_KEY);
          if (raw) {
            const parsed = JSON.parse(raw);
            const age = Date.now() - (parsed._cachedAt || 0);
            if (age < POLL_EVERY && typeof parsed.configured_offered_discount_pct === 'number') {
              setOfferedDiscountPct(prev =>
                prev !== parsed.configured_offered_discount_pct
                  ? parsed.configured_offered_discount_pct
                  : prev
              );
              return;
            }
          }
        } catch { }
      }
      try {
        const response = await apiRequest(
          `${process.env.REACT_APP_MEDICINE_API_URL}/pricing-config`,
          { method: 'GET', headers: { 'Content-Type': 'application/json' } }
        );
        if (!response.ok) { setOfferedDiscountPct(prev => prev ?? 20); return; }
        const data = await response.json();
        const newPct = data.configured_offered_discount_pct ?? 20;
        setOfferedDiscountPct(prev => (prev !== newPct ? newPct : prev));
        sessionStorage.setItem(CACHE_KEY, JSON.stringify({ ...data, _cachedAt: Date.now() }));
      } catch {
        setOfferedDiscountPct(prev => prev ?? 20);
      }
    };

    fetchPricingConfig(false);
    // pricingPollRef.current = setInterval(() => fetchPricingConfig(true), POLL_EVERY);
    const schedulePoll = () => {
      pricingPollRef.current = setTimeout(() => {
        fetchPricingConfig(true).then(schedulePoll);
      }, POLL_EVERY);
    };
    schedulePoll();
    const handleVisibility = () => {
      if (document.visibilityState === 'visible') fetchPricingConfig(true);
    };
    document.addEventListener('visibilitychange', handleVisibility);
    return () => {
      clearInterval(pricingPollRef.current);
      document.removeEventListener('visibilitychange', handleVisibility);
    };
  }, []);

useEffect(() => {
    fetchCommunities()
   },[])
  const fetchCommunities = async () => {
  
      try {
  
        const response = await axios.get(
          `${API_URL}/community/config`
        );
  
        setCommunities(
          response.data.communities || []
        );
        sessionStorage.setItem("communities",JSON.stringify(response.data.communities))
  
      } catch (error) {
  
        console.error(
          "Error fetching communities:",
          error
        );
  
        
  
      } 
    };
  


   const fetchUserByPhone = async (phoneNumber) => {
      let cleanedPhone = phoneNumber.trim();
      if (cleanedPhone.startsWith('+91')) cleanedPhone = cleanedPhone.substring(3);
      else if (cleanedPhone.startsWith('91') && cleanedPhone.length === 12) cleanedPhone = cleanedPhone.substring(2);
      cleanedPhone = cleanedPhone.replace(/[\s-]/g, '');
    
      if (cleanedPhone.length !== 10 || !/^[6-9]\d{9}$/.test(cleanedPhone)) return;
    
      setLoadingUserData(true);
      try {
        const apiUrl = process.env.REACT_APP_GET_USER_BY_PHONE_API;
        const response = await axios.get(`${apiUrl}/${cleanedPhone}`, {
          headers: { "Content-Type": "application/json" }
        });
    
        const data = response.data;
    
        if (data.success && data.user) {
          // ✅ Registered user - auto-fill
          setUserFound(true);
          setDialogMessage(`User details have been loaded.`);
          setDialogOpen(true);
          setPatientDetails((prev) => ({
          ...prev, // keep existing values
          name: data.user.name || '',
          email: data.user.email || '',
          age: data.user.age || '',
          gender:normalizeGender(data.user.gender),
    }));
        } else {
          // Not found in response
          setUserFound(false);
          setDialogMessage("Phone number not registered. Please fill in the details manually.");
          setDialogOpen(true);
        }
      } catch (error) {
        setUserFound(false);
    
        if (error.response?.status === 404) {
          // ✅ Unregistered - show manual entry message
          setDialogMessage("Phone number not registered. Please fill in the details manually.");
        } else {
          // Network or server error
          setDialogMessage("Could not verify phone number. Please fill in the details manually.");
        }
        setDialogOpen(true);
      } finally {
        setLoadingUserData(false);
      }
    };
  
    const normalizeGender = (genderValue) => {
    if (!genderValue) return "";
    
    const normalized = genderValue.toLowerCase().trim();
    
    // Map variations to standard values
    if (normalized === "male" || normalized === "m") return "Male";
    if (normalized === "female" || normalized === "f") return "Female";
    if (normalized === "other" || normalized === "others") return "other";
    
    // Return original if it matches exactly
    if (["Male", "Female", "other"].includes(genderValue)) return genderValue;
    
    // Default to original value
    return genderValue;
  };
  // ─── AYUJA: fetch order-level prices whenever cart changes ────────────────
  useEffect(() => {
    if (cart.length === 0) {
      setAyujaCartPrices({});
      setAyujaSummary(null);
      lastFetchedCartKey.current = '';
      return;
    }

    const cartKey = cart
      .map(i => `${i.medicine_id}:${i.quantity}`)
      .sort()
      .join('|');

    if (cartKey === lastFetchedCartKey.current) return;

    const fetchAyujaPrices = async () => {
      try {
        const response = await apiRequest(
          `${process.env.REACT_APP_MEDICINE_API_URL}/calculate-order-price`,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: cart.map(i => ({
                medicine_id: i.medicine_id,
                quantity: i.quantity,
              })),
            }),
          }
        );
        if (!response.ok) return;
        const data = await response.json();

        const priceMap = {};
        if (data.item_breakdown) {
          data.item_breakdown.forEach(item => {
            priceMap[item.medicine_id] = item.selling_price;
            setPackDiscountPrice(item.pack_disc_price)
          });
        }
        if (cart) {
          cart.forEach(cartItem => {
            const matchedItem = data.item_breakdown.find(
              item => item.medicine_id === cartItem.medicine_id
            );

            if (matchedItem) {
              cartItem.discounted_price = matchedItem.selling_price;
            }
          });
        }
        setAyujaCartPrices(priceMap);
        setAyujaSummary(data);
        lastFetchedCartKey.current = cartKey;
      } catch (err) {
        console.error('AYUJA POS fetch error:', err);
      }
    };

    fetchAyujaPrices();
  }, [cart]);

  // useEffect(() => {
  //   fetchMedicines();
  // }, []);

  useEffect(() => {
    if (medicinesFetchedRef.current) return; 
    medicinesFetchedRef.current = true;      
    fetchMedicines();
  }, []);


const lastFetchedOrdersKey = useRef('');

// replace the useEffect
useEffect(() => {
  if (activeTab !== 'history') return;
  if (!selectedDate) return;

  // Only refetch if tab+date actually changed, not on every re-render
  const key = `${activeTab}:${selectedDate}:${refresh}`;
  if (key === lastFetchedOrdersKey.current) return;
  lastFetchedOrdersKey.current = key;

  fetchOrders();
}, [activeTab, selectedDate,refresh]);

    useEffect(() => {
      if (qrFetchedRef.current) return;
      qrFetchedRef.current = true;     
      const fetchQrUrl = async () => {
      try {
        const response = await apiRequest(
          `${process.env.REACT_APP_MEDICINE_API_URL}/payment-qr-url`
        );
        const data = await response.json();
        setQrCodeUrl(data.url);
      } catch (err) {
        console.error("Failed to fetch QR code URL:", err);
      }
    };
    fetchQrUrl();
  }, []);

    // ── load razorpay ─────────────────────────────────────────────────────────
    useEffect(() => {
      if (window.Razorpay) { setRazorpayLoaded(true); return; }
      const s = document.createElement('script');
      s.src = process.env.REACT_APP_RAZORPAY_SCRIPT;
      s.async = true;
      s.onload = () => setRazorpayLoaded(true);
      s.onerror = () => { setDialogMessage('Failed to load payment gateway. Please refresh.'); setDialogOpen(true); };
      document.body.appendChild(s);
    }, []);

  const fetchMedicines = async () => {
    try {
      const response = await apiRequest(process.env.REACT_APP_GET_MEDICINES);
      const data = await response.json();
      if (data.medicines) {
        setMedicines(data.medicines.filter(m => m.is_active));
      }
    } catch (error) {
      notify('Failed to load medicines', 'error');
    }
  };

  const fetchOrders = async () => {
    try {
      const response = await apiRequest(`${process.env.REACT_APP_MEDICINE_API_URL}/admin/medicine-orders`);
      const data = await response.json();
      if (data.orders) {
        const filtered = data.orders.filter(order => {
          const orderDate = new Date(order.created_at).toLocaleDateString('en-CA');
          const isWalkIn = order.notes?.includes('[POS]');
          return orderDate === selectedDate && isWalkIn;
        });
        setOrders(filtered);
        setRefresh(false)
      }
    } catch (error) {
      notify('Failed to load orders', 'error');
    }
  };

  const viewOrderDetails = (order) => {
    setSelectedOrder(order);
    setShowOrderDetails(true);
  };

  const filteredMedicines = searchQuery.trim().length > 0
    ? medicines.filter(med =>
      med.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      med.manufacturer?.toLowerCase().includes(searchQuery.toLowerCase())
    )
    : [];

  const addToCart = (medicine) => {
    const existing = cart.find(item => item.medicine_id === medicine.medicine_id);
    if (existing) {
      if (existing.quantity >= medicine.stock) {
        notify(`Only ${medicine.stock} units available`, 'warning');
        return;
      }
      setCart(cart.map(item =>
        item.medicine_id === medicine.medicine_id
          ? { ...item, quantity: item.quantity + 1 }
          : item
      ));
    } else {
      setCart([...cart, {
        ...medicine,
        quantity: 1,
        unit_price: medicine.price,
      }]);
    }
  };

  const getCartItem = (medicineId) => {
    return cart.find(item => item.medicine_id === medicineId);
  };

  const updateQuantity = (medicineId, quantity) => {
    if (quantity < 1) {
      removeFromCart(medicineId);
      return;
    }
    const medicine = medicines.find(m => m.medicine_id === medicineId);
    if (quantity > medicine.stock) {
      notify(`Only ${medicine.stock} units available`, 'warning');
      return;
    }
    setCart(cart.map(item =>
      item.medicine_id === medicineId ? { ...item, quantity } : item
    ));
  };

  const removeFromCart = (medicineId) => {
    setCart(cart.filter(item => item.medicine_id !== medicineId));
    setPackDiscountPrice(null)
  };

  const clearCart = () => {
    if (window.confirm('Clear all items from cart?')) {
      setCart([]);
      setDiscountValue(0);
      setDiscountType('flat');
    }
  };

  const formatISTTimestamp = (isoString) => {
    if (!isoString) return 'N/A';
    const asUTC = isoString.endsWith('Z') ? isoString : isoString + 'Z';
    return new Date(asUTC).toLocaleString('en-IN', {
      day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hour12: true,
    });
  };

  // ─── Pricing helpers (AYUJA-aware) ────────────────────────────────────────

  // MRP subtotal (before AYUJA discount)
  const getMrpSubtotal = () =>
    cart.reduce((sum, item) => sum + (item.unit_price * item.quantity), 0);

  // AYUJA selling subtotal
  const getSubtotal = () =>
    cart.reduce((sum, item) => {
      const ayujaPrice = ayujaCartPrices[item.medicine_id];
      const effectivePrice = ayujaPrice !== undefined ? ayujaPrice : (item.unit_price || 0);
      return sum + effectivePrice * item.quantity;
    }, 0);

  // AYUJA savings
  const getAyujaSavings = () => getMrpSubtotal() - getSubtotal();

  const getDiscountAmount = () => {
    if (discountType === 'percentage') {
      return (getSubtotal() * discountValue) / 100;
    }
    return discountValue;
  };

  const getTotal = () => {
    return Math.max(0, getSubtotal() - getDiscountAmount());
  };

  // Per-item AYUJA selling price
  const getItemSellingPrice = (item) => {
    const ayujaPrice = ayujaCartPrices[item.medicine_id];
    return ayujaPrice !== undefined ? ayujaPrice : (item.unit_price || 0);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleCheckout = () => {
    if (cart.length === 0) { notify('Cart is empty', 'warning'); return; }
    if (!patientDetails.name.trim()) { notify('Please enter patient name', 'warning'); return; }
    if (patientDetails.email && !validateEmail(patientDetails.email)) {
      notify('Please enter valid patient email', 'warning');
      return;
    }
    if (!patientDetails.phone.trim() || patientDetails.phone.length !== 10) {
      notify('Please enter valid 10-digit phone number', 'warning'); return;
    }
    setShowPaymentDialog(true);
  };

  // ─── GST calculation (uses AYUJA selling price) ───────────────────────────
  const calculateGST = (items) => {
    let totalCGST = 0, totalSGST = 0, totalIGST = 0, totalGST = 0, totalBasePrice = 0;

    items.forEach(item => {
      const medicine = medicines.find(m => m.medicine_id === item.medicine_id);
      if (!medicine) return;

      const cgst = medicine.cgst || 0;
      const sgst = medicine.sgst || 0;
      const igst = medicine.igst || 0;
      const gst_rate = igst > 0 ? igst : (cgst + sgst);

      // Use AYUJA selling price if available
      const ayujaPrice = ayujaCartPrices[item.medicine_id];
      const effectiveUnitPrice = ayujaPrice !== undefined ? ayujaPrice : (item.unit_price || item.price || 0);
      const price = effectiveUnitPrice * item.quantity;

      const basePrice = price / (1 + gst_rate / 100);
      const gstAmount = price - basePrice;

      totalBasePrice += basePrice;
      totalGST += gstAmount;
      if (igst > 0) {
        totalIGST += gstAmount;
      } else {
        totalCGST += (gstAmount / 2);
        totalSGST += (gstAmount / 2);
      }
    });

    return { basePrice: totalBasePrice, cgst: totalCGST, sgst: totalSGST, igst: totalIGST, totalGST };
  };

  const gstBreakdown = calculateGST(cart);

  const processOrder = async () => {
    const cartWithAyujaPrices = cart.map(item => ({
        ...item,
        unit_price: getItemSellingPrice(item),
      }));
      if (
        orderCreatePymentFailed &&
        currentOrder &&
        currentOrder.order_id
      ) {
        console.log(orderCreatePymentFailed)
        setShowPaymentDialog(true);
        if (paymentMethod === 'upi'){
          handleOnlinePayment(currentOrder)
        }
        else{
          await markOrderDelivered(currentOrder.order_id);
          notify('Order completed successfully!', 'success');
          
          setTimeout(() => {
            printBill({
              order_id: currentOrder.order_id,
              items: cartWithAyujaPrices,
              patient_details: patientDetails,
              subtotal: getSubtotal(),
              mrp_subtotal: getMrpSubtotal(),
              ayuja_savings: getAyujaSavings(),
              discount: getDiscountAmount(),
              total_amount: getTotal(),
              payment: { method: paymentMethod },
              created_at: new Date().toISOString(),
              ayuja_summary: ayujaSummary,
              stock_deduction:currentOrder.stock_deduction
            });
          }, 100);
          const payment={payment: {
          payment_id: paymentMethod === 'cash'
            ? `CASH_${Date.now()}`
            : `UPI_${Date.now()}`,
          method: "offline",
          status: paymentMethod === 'cash' ? "success" : "pending",
          transaction_history: [{
            timestamp: new Date().toISOString(),
            method: paymentMethod,
            status: paymentMethod === 'cash' ? "success" : "pending",
          }]},
        }
          try{
             const response = await apiRequest(
        `${process.env.REACT_APP_UPDATE_PAYMENT_API}/${currentOrder.order_id}`,
        
        {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payment),
        }
      );
    }
    catch(error){
        console.log(error)
    }
          resetPOS();
          setRefresh(true)
        }
        return;
      }
    setLoading(true);
    try {
      // Build cart items with AYUJA prices embedded
      
      const orderData = {
        ...(patientDetails.email && { user_email: patientDetails.email }),
        user_phone: patientDetails.phone,
        order_type: "pharmacy",
        items: cartWithAyujaPrices.map(item => ({
          medicine_id: item.medicine_id,
          quantity: item.quantity,
          hsn_code: item.hsn_code,
          pack_size: item.pack_size,
          batch_number: item.batch_number,
          manufacturer: item.manufacturer,
        })),
        delivery_address: {
          full_name: patientDetails.name,
          phone: patientDetails.phone,
          community_name: patientDetails.community_name,
          address_line1: "In-store purchase - POS",
          address_line2: "",
          landmark: "",
          city: "",
          state: "",
          pincode: "",
          address_type: "store",
          delivery_time_option: "immediate",
          delivery_time: new Date().toISOString(),
        },
        order_from:"In-Store Purchase",
        payment: {
          payment_id: paymentMethod === 'cash'
            ? `CASH_${Date.now()}`
            : `UPI_${Date.now()}`,
          method: "offline",
          status: paymentMethod === 'cash' ? "success" : "pending",
          transaction_history: [{
            timestamp: new Date().toISOString(),
            method: paymentMethod,
            status: paymentMethod === 'cash' ? "success" : "pending",
          }],
        },
        paymentDetails: {
          razorpay_payment_id: paymentMethod === 'cash'
            ? `CASH_${Date.now()}`
            : `UPI_${Date.now()}`,
          razorpay_order_id: `ORDER_${Date.now()}`,
          razorpay_signature: "POS_SIGNATURE",
        },
        discount: getDiscountAmount(),
        subtotal: getSubtotal(),
        total_amount: getTotal(),
        patient_details: {
          name: patientDetails.name,
          dob: patientDetails.age,
          phone: patientDetails.phone,
          gender: patientDetails.gender,
          doctorname: patientDetails.doctorname,
        },
      };

      const response = await apiRequest(
        process.env.REACT_APP_CREATE_MEDICINE_ORDER,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(orderData),
        }
      );

      const data = await response.json();
      

      if (response.ok && data.order_id) {
        const orderId = data.order_id;
        const stock_deduction=data.stock_deduction
        if (paymentMethod === 'upi') {
          const orderObj = {
            order_id: orderId,
            items: cartWithAyujaPrices,
            patient_details: patientDetails,
            subtotal: getSubtotal(),
            mrp_subtotal: getMrpSubtotal(),
            ayuja_savings: getAyujaSavings(),
            discount: getDiscountAmount(),
            total_amount: getTotal(),
            ayuja_summary: ayujaSummary,
            stock_deduction: stock_deduction
          };

          setCurrentOrder(orderObj);
          setShowPaymentDialog(false);

          handleOnlinePayment(orderObj);
         
        } else {
          await markOrderDelivered(orderId);
          notify('Order completed successfully!', 'success');

          setTimeout(() => {
            printBill({
              order_id: orderId,
              items: cartWithAyujaPrices,
              patient_details: patientDetails,
              subtotal: getSubtotal(),
              mrp_subtotal: getMrpSubtotal(),
              ayuja_savings: getAyujaSavings(),
              discount: getDiscountAmount(),
              total_amount: getTotal(),
              payment: { method: paymentMethod },
              created_at: new Date().toISOString(),
              ayuja_summary: ayujaSummary,
              stock_deduction:stock_deduction
            });
          }, 100);

          resetPOS();
          setRefresh(true)
        }
      } else {
        notify(data.error || 'Order failed', 'error');
      }
    } catch (error) {
      console.error('Order error:', error);
      notify('Failed to create order', 'error');
    } finally {
      setLoading(false);
    }
  };

  const markOrderDelivered = async (orderId) => {
    try {
      const orderResponse = await apiRequest(
        `${process.env.REACT_APP_MEDICINE_API_URL}/admin/medicine-orders/${orderId}`
      );
      if (!orderResponse.ok) { console.error('Failed to fetch order'); return; }
      const orderData = await orderResponse.json();
      const currentNotes = orderData.order?.notes || "";

      const updateResponse = await apiRequest(
        `${process.env.REACT_APP_MEDICINE_API_URL}/medicine-orders/${orderId}`,
        {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            order_status: "delivered",
            delivery_status: "delivered",
            total_amount: getTotal(),
            subtotal: getSubtotal(),
            delivery_address: {
              full_name: patientDetails.name,
              phone: patientDetails.phone,
              community_name: patientDetails.community_name,
              address_line1: "In-store purchase - POS",
              address_type: "store",
            },
            discount: getDiscountAmount(),
            updated_at: new Date().toISOString(),
            notes: `${currentNotes}\n[POS] Patient: ${patientDetails.name} (${patientDetails.email || 'No Email'}) - ${paymentMethod.toUpperCase()} - Served by: ${staffName} - ${new Date().toLocaleString()}`,
          }),
        }
      );

      if (!updateResponse.ok) {
        const errorData = await updateResponse.json();
        console.error('Failed to update order:', errorData);
        throw new Error('Order update failed');
      }
    } catch (error) {
      console.error('Error marking order as delivered:', error);
      throw error;
    }
  };

  const completeUpiPayment = async (paymentSuccess,orderObj) => {
    console.log(paymentSuccess)
    if (!paymentSuccess.razorpay_payment_id) { notify('Please enter UPI transaction ID', 'warning'); return; }
    setLoading(true);
    try {
      console.log(currentOrder)
      const orderId = orderObj.order_id;
      const stock_deduction=orderObj.stock_deduction
      const response = await apiRequest(
        `${process.env.REACT_APP_MEDICINE_API_URL}/medicine-orders/${orderId}/payment`,
        {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            payment_id: paymentSuccess.razorpay_payment_id,
            order_id: paymentSuccess.razorpay_order_id,
            method: "online",
            status: "success",
            gateway: "Razorpay",
            currency: "INR",
          }),
        }
      );

      if (response.ok) {
        await markOrderDelivered(orderId);
        notify('Payment completed successfully!', 'success');

        setTimeout(() => {
          printBill({
            order_id: orderId,
            items: orderObj.items,
            patient_details: orderObj.patient_details,
            subtotal: orderObj.subtotal,
            mrp_subtotal: orderObj.mrp_subtotal,
            ayuja_savings: orderObj.ayuja_savings,
            discount: orderObj.discount,
            total_amount: orderObj.total_amount,
            payment: { method: 'upi' },
            created_at: new Date().toISOString(),
            upi_transaction_id: paymentSuccess.razorpay_payment_id,
            ayuja_summary: orderObj.ayuja_summary,
            stock_deduction:stock_deduction
          });
        }, 100);

        resetPOS();
        setShowUpiDialog(false);
        setRefresh(true)
      } else {
        notify('Payment update failed', 'error');
      }
    } catch (error) {
      notify('Failed to update payment', 'error');
    } finally {
      setLoading(false);
    }
  };
const handleOnlinePayment = async (orderObj) => {    
    const totalValue=getTotal()
    if (!razorpayLoaded || !window.Razorpay) { 
      setDialogMessage('Payment gateway is loading. Please try again.'); setDialogOpen(true); return; }
    const userData = currentUser || { email: patientDetails.email };
    try {
      setLoading(true);
      const orderRes = await apiRequest(process.env.REACT_APP_CREATE_RAZORPAY_ORDER, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ amount: totalValue, currency: 'INR', receipt: `medicine_${Date.now()}`, notes: { order_type: "In-Store", customer_email: userData.email },service_type:"In-Store",
          customer_name:patientDetails.name,contact: patientDetails.phone }),
      });
      const orderData = await orderRes.json();
      if (!orderRes.ok) throw new Error(orderData.error || 'Failed to create payment order');
      setLoading(false);
      const rzp = new window.Razorpay({
        key: process.env.REACT_APP_RAZORPAY_KEY || 'rzp_test_RLPNXraO5Rywls',
        amount: orderData.totalAmount, currency: orderData.currency,
        name: 'Ayuja Medicines', description: `Medicine Order - In-Store`,
        order_id: orderData.id,
        prefill: { name: patientDetails.name, email: patientDetails.email, contact: patientDetails.phone },
        theme: { color: '#006D77' },
        handler: async (paymentSuccess) => {
          setLoading(true);
          try {
            const verifyRes = await apiRequest(process.env.REACT_APP_PROCESS_PAYEMENT, {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ razorpay_payment_id: paymentSuccess.razorpay_payment_id, razorpay_order_id: paymentSuccess.razorpay_order_id, razorpay_signature: paymentSuccess.razorpay_signature, method: 'online', amount: orderData.totalAmount }),
            });
            const paymentResult = await verifyRes.json();
            if (paymentResult.status !== 'success') throw new Error('Payment verification failed');
            console.log(paymentSuccess)
            setUpiTransactionId(paymentSuccess.razorpay_payment_id)
            await completeUpiPayment(paymentSuccess,orderObj);
          } catch (error) {
            setLoading(false);
            setDialogMessage('Payment successful but order creation failed. Contact support with payment ID: ' + paymentSuccess.razorpay_payment_id);
            setDialogOpen(true);
          }
        },
        modal: {
          ondismiss: () => {
            setLoading(false);
          // Go back to payment selection dialog
          // Keep the existing order so it can be reused
          setShowPaymentDialog(true)
          notify('Payment cancelled.choose another payment method.', 'warning'); 
          setOrderCreatePymentFailed(true)

          },
        },
      });
      rzp.on('payment.failed', (r) => {
        setLoading(false);
        if (window.confirm(`Payment Failed: ${r.error.description || r.error.message}. Try again?`)) handleOnlinePayment();
                
        setOrderCreatePymentFailed(true)
      });
      rzp.open();
    } catch (error) {
      setOrderCreatePymentFailed(true)
      setDialogMessage(error.message || 'Failed to initialize payment.'); setDialogOpen(true); setLoading(false);
    }
  };
  const resetPOS = () => {
    setCart([]);
    setDiscountValue(0);
    setDiscountType('flat');
    setPatientDetails({ name: '', email: '', phone: '', age: '', gender: '', doctorname: '' });
    setPaymentMethod('cash');
    setCurrentOrder(null);
    setUpiTransactionId('');
    setShowPaymentDialog(false);
    setSearchQuery('');
    setAyujaCartPrices({});
    setAyujaSummary(null);
    lastFetchedCartKey.current = '';
    // setTimeout(() => { window.location.reload(); }, 500);
  };

  const notify = (message, type = 'info') => {
    setNotification({ message, type });
    setTimeout(() => setNotification(null), 3000);
  };
    const handleInvoiceDownload=async(order_id)=>{
          try {
                const token = sessionStorage.getItem("token");
    
                const response = await axios.get(
                  `${process.env.REACT_APP_API_INVOICE}/invoice/download/${order_id}`,
                  {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  }
                );
                
              const download_url=response.data.download_url
                window.open(download_url, "_blank");
    
              } catch (error) {
                console.error("Invoice download failed:", error);
              }
    }
    

  // ─── Print Bill (AYUJA-aware) ─────────────────────────────────────────────
  const printBill = async(order) => {
    const orderItems = order.items || cart;
    const gst = calculateGST(orderItems);

    const calculateItemGST = (item) => {
      const medicine = medicines.find(m => m.medicine_id === item.medicine_id);
      if (!medicine) {
        return { cgst: 0, sgst: 0, igst: 0, gstRate: 0, basePrice: (item.unit_price || 0) * item.quantity, gstAmount: 0, totalPrice: (item.unit_price || 0) * item.quantity };
      }
      const cgst = medicine.cgst || 0;
      const sgst = medicine.sgst || 0;
      const igst = medicine.igst || 0;
      const gstRate = igst > 0 ? igst : (cgst + sgst);
      const totalPrice = (item.unit_price || item.price || 0) * item.quantity;
      const basePrice = totalPrice / (1 + gstRate / 100);
      const gstAmount = totalPrice - basePrice;
      let cgstAmount = 0, sgstAmount = 0, igstAmount = 0;
      if (igst > 0) { igstAmount = gstAmount; } else { cgstAmount = gstAmount / 2; sgstAmount = gstAmount / 2; }
      return { cgst, sgst, igst, gstRate, basePrice, gstAmount, cgstAmount, sgstAmount, igstAmount, totalPrice };
    };

    const mrpSubtotal = order.mrp_subtotal || orderItems.reduce((s, i) => s + (i.price || i.unit_price || 0) * i.quantity, 0);
    const ayujaSavings = order.ayuja_savings || 0;
    const sellingSubtotal = order.subtotal || 0;
    const discountAmt = order.discount || 0;
    const grandTotal = order.total_amount || 0;
    const ayujaDiscPct = mrpSubtotal > 0 ? ((ayujaSavings / mrpSubtotal) * 100).toFixed(2) : '0.00';
    const ayujaSummaryData = order.ayuja_summary || {};
    console.log(order)
    const community_name=sessionStorage.getItem('user')
    const community="Honer Vivantis"
    const posOrderData={ 
              service_type:"medicine",
              order_id: order.order_id, 
              items: cart, 
              patient_details: patientDetails,
              subtotal: mrpSubtotal,
              // discount: discount,
              discount: ayujaSavings,
              community_name:community,
              total_amount: grandTotal,
              payment: { method: paymentMethod },
              created_at: new Date().toISOString(),
              batchInfo:order.stock_deduction 
            }
              try {
            const invoice_response = await axios.post(
              `${process.env.REACT_APP_API_INVOICE}/invoice/pos_invoice`,
              posOrderData,
            );
      
          const invoice = invoice_response.data.invoice_details;
          if (invoice.storage_type === "s3") {
            // Open CloudFront URL
            window.open(invoice.cloudfront_url, "_blank");
          } else if (invoice.storage_type === "local") {
            try {
            const token = sessionStorage.getItem("token");

            const response = await axios.get(
              `${process.env.REACT_APP_API_INVOICE}/invoice/download/${posOrderData.order_id}`,
              {
                responseType: "blob",
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );

            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = window.URL.createObjectURL(blob);

            window.open(url, "_blank");

          } catch (error) {
            console.error("Invoice download failed:", error);
          }
          }
          } catch (error) {
            console.error("Invoice generation failed:", error);
          }

  };

  // ─── Derived display values ────────────────────────────────────────────────
  const mrpSubtotal = getMrpSubtotal();
  const ayujaSubtotal = getSubtotal();
  const ayujaSavings = getAyujaSavings();
  const hasAyuja = Object.keys(ayujaCartPrices).length > 0;
  const ayujaDiscPct = mrpSubtotal > 0 ? ((ayujaSavings / mrpSubtotal) * 100) : 0;

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f5f5f5', marginLeft: "300px" }}>
      {/* Header */}
      <div style={{
        backgroundColor: '#006d77', color: 'white', padding: '16px 24px',
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <span style={{ fontSize: '24px' }}>🛒</span>
          <h1 style={{ margin: 0, fontSize: '20px' }}>Medicine POS System</h1>
        </div>
        {offeredDiscountPct !== null && (
          <div style={{ backgroundColor: 'rgba(255,255,255,0.2)', padding: '6px 14px', borderRadius: '20px', fontSize: '13px', fontWeight: '600' }}>
            🎯 Up to {offeredDiscountPct}% OFF via AYUJA
          </div>
        )}
      </div>

      {/* Tabs */}
      <div style={{ backgroundColor: 'white', padding: '0 24px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
        <div style={{ display: 'flex', gap: '8px' }}>
          {[['sale', '🛍️ New Sale'], ['history', '📋 Order History']].map(([tab, label]) => (
            <button key={tab} onClick={() => setActiveTab(tab)} style={{
              padding: '16px 24px', border: 'none',
              borderBottom: activeTab === tab ? '3px solid #006d77' : '3px solid transparent',
              backgroundColor: 'transparent', cursor: 'pointer',
              fontWeight: activeTab === tab ? 'bold' : 'normal',
              color: activeTab === tab ? '#006d77' : '#666',
            }}>
              {label}
            </button>
          ))}
        </div>
      </div>

      <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '24px' }}>
        {activeTab === 'sale' ? (
          <div style={{ display: 'grid', gridTemplateColumns: '1.5fr 600px', gap: '24px' }}>

            {/* ─── Left panel: Patient + Cart ─────────────────────────────────── */}
            <div style={{
              backgroundColor: 'white', borderRadius: '8px', padding: '24px',
              height: 'calc(100vh - 180px)', display: 'flex', flexDirection: 'column',
            }}>
              {/* Patient Details */}
              <div style={{ marginBottom: '16px' }}>
                <h3 style={{ margin: '0 0 12px 0', fontSize: '14px', fontWeight: 'bold' }}>Patient Details *</h3>
                {[
                  { type: 'text', placeholder: 'Patient Name *', field: 'name' },
                  { type: 'email', placeholder: 'Patient Email (Optional)', field: 'email' },
                ].map(({ type, placeholder, field }) => (
                  <input key={field} type={type} placeholder={placeholder} value={patientDetails[field]}
                    onChange={(e) => setPatientDetails({ ...patientDetails, [field]: e.target.value })}
                    style={{ width: '100%', padding: '8px', marginBottom: '8px', border: '1px solid #e0e0e0', borderRadius: '4px', fontSize: '14px' }}
                  />
                ))}
                <input type="tel" placeholder="Phone (10 digits) *" value={patientDetails.phone}
                  onChange={(e) => {
                    const phone = e.target.value.replace(/\D/g, '');
                    setPatientDetails({
                      ...patientDetails,
                      phone,
                    });

                    // Call API only when exactly 10 digits entered
                    if (phone.length === 10) {
                      fetchUserByPhone(phone);
                    }
                  }}
                  maxLength="10"
                  style={{ width: '100%', padding: '8px', marginBottom: '8px', border: '1px solid #e0e0e0', borderRadius: '4px', fontSize: '14px' }}
                />
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
                  <input type="number" placeholder="Age (Optional)" value={patientDetails.age}
                    onChange={(e) => setPatientDetails({ ...patientDetails, age: e.target.value })}
                    style={{ padding: '8px', border: '1px solid #e0e0e0', borderRadius: '4px', fontSize: '14px' }}
                  />
                  <select value={patientDetails.gender}
                    onChange={(e) => setPatientDetails({ ...patientDetails, gender: e.target.value })}
                    style={{ padding: '8px', border: '1px solid #e0e0e0', borderRadius: '4px', fontSize: '14px' }}>
                    <option value="">Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </select>
                  <select value={patientDetails.community_name || ''}
                    onChange={(e) => setPatientDetails({ ...patientDetails, community_name: e.target.value })}
                    style={{ width: '100%', padding: '8px', marginBottom: '8px', border: '1px solid #e0e0e0', borderRadius: '4px', fontSize: '14px' }}>
                    <option value="">Select Community</option>
                    {/* {communities.map((community, index) => (
                      <option key={index} value={community.name}>{community.name}</option>
                    ))} */}
                     
                      <option key="Honer Vivantis" value="Honer Vivantis">Honer Vivantis</option>

                  </select>
                </div>
              </div>

              <input type="text" placeholder="Doctor Name"
                value={patientDetails.doctorname}
                onChange={(e) => setPatientDetails({ ...patientDetails, doctorname: e.target.value })}
                style={{ width: '100%', padding: '8px', marginBottom: '8px', border: '1px solid #e0e0e0', borderRadius: '4px', fontSize: '14px' }}
              />

              <hr style={{ margin: '16px 0', border: 'none', borderTop: '1px solid #e0e0e0' }} />

              {/* Cart */}
              <div style={{ flex: 1, overflow: 'auto', minHeight: '200px', maxHeight: 'calc(100vh - 600px)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
                  <h3 style={{ margin: 0, fontSize: '14px', fontWeight: 'bold' }}>Cart ({cart.length})</h3>
                  {cart.length > 0 && (
                    <button onClick={clearCart} style={{ padding: '6px 12px', border: 'none', backgroundColor: '#f8d7da', color: '#842029', borderRadius: '6px', cursor: 'pointer', fontSize: '13px', fontWeight: 500 }}>
                      Clear Cart
                    </button>
                  )}
                </div>

                {cart.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: '48px 0', color: '#999' }}>
                    <div style={{ fontSize: '48px' }}>🛒</div>
                    <p>Cart is empty</p>
                  </div>
                ) : (
                  cart.map(item => {
                    const mrpPrice = item.price || item.unit_price || 0;
                    const sellingPrice = getItemSellingPrice(item);
                    const saved = (mrpPrice - sellingPrice) * item.quantity;
                    const discPct = mrpPrice > 0 ? ((mrpPrice - sellingPrice) / mrpPrice * 100) : 0;
                    return (
                      <div key={item.medicine_id} style={{ padding: '12px', marginBottom: '8px', backgroundColor: '#fafafa', borderRadius: '4px', border: hasAyuja && discPct > 0 ? '1px solid #d1fae5' : '1px solid #eee' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                          <div style={{ flex: 1 }}>
                            <strong style={{ fontSize: '14px' }}>{item.name}</strong>
                            <div style={{ fontSize: '12px', color: '#666', marginTop: 2 }}>
                              {hasAyuja && discPct > 0 ? (
                                <>
                                  <span style={{ textDecoration: 'line-through', color: '#9CA3AF' }}>₹{mrpPrice.toFixed(2)}</span>
                                  {' '}
                                  <span style={{ color: '#16a34a', fontWeight: 600 }}>₹{sellingPrice.toFixed(2)}</span>
                                  {' '}
                                  <span style={{ backgroundColor: '#fff7ed', color: '#ea580c', border: '1px solid #fed7aa', borderRadius: 3, padding: '0 4px', fontSize: 10, fontWeight: 700 }}>
                                    {discPct.toFixed(1)}% OFF
                                  </span>
                                </>
                              ) : (
                                <span>₹{mrpPrice.toFixed(2)}</span>
                              )}
                              {' × '}{item.quantity}
                            </div>
                          </div>
                          <button onClick={() => removeFromCart(item.medicine_id)} style={{ border: 'none', background: 'transparent', cursor: 'pointer', fontSize: '18px', color: '#999' }}>×</button>
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                            <button onClick={() => updateQuantity(item.medicine_id, item.quantity - 1)} style={{ width: '28px', height: '28px', border: '1px solid #ddd', background: 'white', borderRadius: '4px', cursor: 'pointer' }}>−</button>
                            <input type="number" value={item.quantity}
                              onChange={(e) => updateQuantity(item.medicine_id, parseInt(e.target.value) || 1)}
                              min="1" max={item.stock}
                              style={{ width: '50px', padding: '4px', textAlign: 'center', border: '1px solid #ddd', borderRadius: '4px' }}
                            />
                            <button onClick={() => updateQuantity(item.medicine_id, item.quantity + 1)} style={{ width: '28px', height: '28px', border: '1px solid #ddd', background: 'white', borderRadius: '4px', cursor: 'pointer' }}>+</button>
                          </div>
                          <div style={{ textAlign: 'right' }}>
                            <strong style={{ fontSize: '16px', color: '#16a34a' }}>₹{(sellingPrice * item.quantity).toFixed(2)}</strong>
                            {hasAyuja && saved > 0 && (
                              <div style={{ fontSize: '11px', color: '#16a34a' }}>save ₹{saved.toFixed(2)}</div>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>

              <hr style={{ margin: '16px 0', border: 'none', borderTop: '1px solid #e0e0e0' }} />

              {/* Totals */}
              <div>
                {/* AYUJA savings banner */}
                {hasAyuja && ayujaSavings > 0 && (
                  <div style={{ backgroundColor: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: '6px', padding: '8px 12px', marginBottom: '10px', display: 'flex', justifyContent: 'space-between' }}>
                    <span style={{ color: '#16a34a', fontWeight: 600, fontSize: '13px' }}>
                      🎯 AYUJA Discount ({ayujaDiscPct.toFixed(1)}% OFF)
                    </span>
                    <span style={{ color: '#16a34a', fontWeight: 700, fontSize: '13px' }}>-₹{ayujaSavings.toFixed(2)}</span>
                  </div>
                )}

                {/* MRP row */}
                {hasAyuja && ayujaSavings > 0 && (
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px', fontSize: '13px', color: '#9CA3AF' }}>
                    <span>MRP Total:</span>
                    <span style={{ textDecoration: 'line-through' }}>₹{mrpSubtotal.toFixed(2)}</span>
                  </div>
                )}

                {/* GST breakdown */}
                {gstBreakdown.cgst > 0 && (
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px', fontSize: '13px', color: '#666' }}>
                    <span>CGST:</span><span>₹{gstBreakdown.cgst.toFixed(2)}</span>
                  </div>
                )}
                {gstBreakdown.sgst > 0 && (
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px', fontSize: '13px', color: '#666' }}>
                    <span>SGST:</span><span>₹{gstBreakdown.sgst.toFixed(2)}</span>
                  </div>
                )}
                {gstBreakdown.igst > 0 && (
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px', fontSize: '13px', color: '#666' }}>
                    <span>IGST:</span><span>₹{gstBreakdown.igst.toFixed(2)}</span>
                  </div>
                )}

                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                  <span>Subtotal (AYUJA Price incl. GST):</span>
                  <strong>₹{ayujaSubtotal.toFixed(2)}</strong>
                </div>

                {/* Additional discount */}
                <div style={{ marginBottom: '12px' }}>
                  <div style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
                    {['flat', 'percentage'].map(type => (
                      <button key={type} onClick={() => setDiscountType(type)} style={{
                        flex: 1, padding: '8px',
                        border: discountType === type ? '2px solid #006d77' : '1px solid #ddd',
                        backgroundColor: discountType === type ? '#e0f2f1' : 'white',
                        borderRadius: '4px', cursor: 'pointer', fontSize: '13px',
                        fontWeight: discountType === type ? 'bold' : 'normal',
                      }}>
                        {type === 'flat' ? '₹ Flat' : '% Percent'}
                      </button>
                    ))}
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span style={{ fontSize: '14px' }}>Additional Discount:</span>
                    <input type="number" value={discountValue}
                      onChange={(e) => {
                        const val = Math.max(0, parseFloat(e.target.value) || 0);
                        setDiscountValue(discountType === 'percentage' ? Math.min(100, val) : Math.min(ayujaSubtotal, val));
                      }}
                      min="0" max={discountType === 'percentage' ? 100 : ayujaSubtotal}
                      style={{ flex: 1, padding: '8px', textAlign: 'right', border: '1px solid #ddd', borderRadius: '4px', fontSize: '14px' }}
                      placeholder={discountType === 'percentage' ? '0-100%' : '₹ Amount'}
                    />
                    <span style={{ fontSize: '14px', color: '#666', minWidth: '20px' }}>
                      {discountType === 'percentage' ? '%' : '₹'}
                    </span>
                  </div>
                  {discountValue > 0 && (
                    <div style={{ fontSize: '12px', color: '#d32f2f', marginTop: '4px', textAlign: 'right' }}>
                      Additional Discount: -₹{getDiscountAmount().toFixed(2)}
                    </div>
                  )}
                </div>

                <hr style={{ margin: '12px 0', border: 'none', borderTop: '2px solid #e0e0e0' }} />

                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px', fontSize: '20px' }}>
                  <strong>Total:</strong>
                  <strong style={{ color: '#006d77' }}>₹{getTotal().toFixed(2)}</strong>
                </div>

                {hasAyuja && (ayujaSavings + getDiscountAmount()) > 0 && (
                  <div style={{ textAlign: 'right', fontSize: '12px', color: '#16a34a', fontWeight: 600, marginBottom: '12px' }}>
                    Total savings: ₹{(ayujaSavings + getDiscountAmount()).toFixed(2)}
                  </div>
                )}

            <button
              onClick={handleCheckout}
              disabled={
                cart.length === 0 ||
                !patientDetails.name.trim() ||
                patientDetails.phone.length !== 10 ||
                (patientDetails.email && !validateEmail(patientDetails.email))
              }
              style={{
                width: '100%',
                padding: '14px',
                backgroundColor:
                  cart.length === 0 ||
                  !patientDetails.name.trim() ||
                  patientDetails.phone.length !== 10 ||
                  (patientDetails.email && !validateEmail(patientDetails.email))
                    ? '#ccc'
                    : '#006d77',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: 'bold',
                cursor:
                  cart.length === 0 ||
                  !patientDetails.name.trim() ||
                  patientDetails.phone.length !== 10 ||
                  (patientDetails.email && !validateEmail(patientDetails.email))
                    ? 'not-allowed'
                    : 'pointer',
              }}
            >
              Proceed to Payment
            </button>
              </div>
            </div>

            {/* ─── Right panel: Medicine Search ──────────────────────────────────── */}
            <div style={{
              backgroundColor: 'white', borderRadius: '8px', padding: '24px',
              height: 'calc(100vh - 200px)', display: 'flex', flexDirection: 'column', overflow: 'hidden',
            }}>
              <div style={{ marginBottom: '16px', flexShrink: 0 }}>
                <input type="text" placeholder="🔍 Search medicines by name or manufacturer..."
                  value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)}
                  style={{ width: '100%', padding: '12px', fontSize: '16px', border: '2px solid #e0e0e0', borderRadius: '8px', marginBottom: '8px' }}
                />
                {offeredDiscountPct !== null && (
                  <div style={{ backgroundColor: '#fff7ed', border: '1px solid #fed7aa', borderRadius: '6px', padding: '6px 12px', fontSize: '12px', color: '#ea580c', fontWeight: 600 }}>
                    🎯 AYUJA Pricing active — patients get up to {offeredDiscountPct}% OFF on all medicines
                  </div>
                )}
              </div>

              <div style={{ flex: 1, overflow: 'auto' }}>
                {searchQuery.trim().length === 0 ? (
                  <div style={{ textAlign: 'center', padding: '48px 0', color: '#999' }}>
                    <div style={{ fontSize: '64px', marginBottom: '16px' }}>🔍</div>
                    <h3 style={{ margin: '0 0 8px 0' }}>Start searching for medicines</h3>
                    <p style={{ margin: 0 }}>Type medicine name or manufacturer to find products</p>
                  </div>
                ) : filteredMedicines.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: '48px 0', color: '#999' }}>
                    <div style={{ fontSize: '64px', marginBottom: '16px' }}>❌</div>
                    <h3>No medicines found</h3>
                  </div>
                ) : (
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: '16px' }}>
                    {filteredMedicines.map(medicine => {
                      const cartItem = getCartItem(medicine.medicine_id);
                      const inCart = !!cartItem;
                      const mrp = medicine.price || 0;
                      const bp = medicine.base_price || 0;
                      const hasBasePrice = bp > 0 && mrp > bp;
                      // Show AYUJA price if in cart
                      const ayujaPrice = ayujaCartPrices[medicine.medicine_id];
                      const displayDisc = ayujaPrice !== undefined
                        ? ((mrp - ayujaPrice) / mrp * 100).toFixed(1)
                        : null;

                      return (
                        <div key={medicine.medicine_id} style={{
                          border: inCart ? '1px solid #006d77' : '1px solid #e0e0e0',
                          borderRadius: '8px', padding: '16px', transition: 'all 0.2s',
                          backgroundColor: inCart ? '#f0fdfa' : 'white',
                        }}>
                          <h3 style={{ margin: '0 0 4px 0', fontSize: '16px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {medicine.name}
                          </h3>
                          <p style={{ margin: '0 0 8px 0', fontSize: '12px', color: '#666' }}>{medicine.manufacturer}</p>
                          {medicine.pack_size > 1 && (
                              <p style={{ margin: '0 0 8px 0', fontSize: '12px', color: '#888', fontWeight: 500 }}>
                                📦 Pack of {medicine.pack_size}
                              </p>
                            )}
                                                {medicine.selling_unit=="loose_allowed" &&
                                                        (<div style={{ display: 'flex', alignItems: 'center', gap: 4}} ><Typography sx={{ fontSize: 15, fontWeight: 600,textDecoration: packDiscountPrice?'line-through':'none' }}>
                                                          MRP ₹{(medicine.price*medicine.pack_size)?.toFixed(2)}
                                                           <Typography 
                                                              component="span"
                                                              sx={{
                                                                ml: 0.3,
                                                                fontSize: 12,
                                                                color: "#3b3f44",
                                                                fontWeight: 500,
                                                              }}> /{medicine.pack_size} Tab</Typography>
                                                        </Typography>
                                                        {packDiscountPrice&&(<Typography style={{ fontSize: '12px', color: '#16a34a',fontWeight: 600 }}>₹{packDiscountPrice?.toFixed(2)}</Typography>)}</div>)}
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                            <div>
                              {medicine.selling_unit!=="loose_allowed"&&
                                                       (
                              <div style={{ fontSize: '13px', color: '#9CA3AF', textDecoration: 'line-through' }}>
                                MRP ₹{mrp.toFixed(2)} 
                              </div>)}
                              {ayujaPrice !== undefined && displayDisc > 0 ? (
                                <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                  <strong style={{ fontSize: '18px', color: '#16a34a' }}>₹{ayujaPrice.toFixed(2)}</strong>
                                  <span style={{ fontSize: '10px', backgroundColor: '#fff7ed', color: '#ea580c', border: '1px solid #fed7aa', borderRadius: 3, padding: '1px 4px', fontWeight: 700 }}>
                                    {displayDisc}% OFF
                                  </span>
                                </div>
                              ) : hasBasePrice && offeredDiscountPct ? (
                                <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                  <strong style={{ fontSize: '18px', color: '#006d77' }}>₹{mrp.toFixed(2)}</strong>
                                  <span style={{ fontSize: '10px', backgroundColor: '#fff7ed', color: '#ea580c', border: '1px solid #fed7aa', borderRadius: 3, padding: '1px 4px', fontWeight: 700 }}>
                                    Up to {offeredDiscountPct}% OFF
                                  </span>
                                </div>
                              ) : (
                                <strong style={{ fontSize: '18px', color: '#006d77' }}>₹{mrp.toFixed(2)}</strong>
                              )}
                            </div>
                            <span style={{
                              padding: '4px 8px', borderRadius: '4px', fontSize: '12px',
                              backgroundColor: medicine.stock > 10 ? '#e8f5e9' : '#fff3e0',
                              color: medicine.stock > 10 ? '#2e7d32' : '#e65100',
                            }}>
                              Stock: {medicine.stock}
                            </span>
                          </div>

                          {inCart ? (
                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center', justifyContent: 'space-between', backgroundColor: 'white', padding: '8px', borderRadius: '6px' }}>
                              <button onClick={(e) => { e.stopPropagation(); updateQuantity(medicine.medicine_id, cartItem.quantity - 1); }}
                                style={{ width: '32px', height: '32px', border: '1px solid #006d77', background: 'white', borderRadius: '4px', cursor: 'pointer', color: '#006d77', fontWeight: 'bold', fontSize: '18px' }}>
                                −
                              </button>
                              <input type="number" value={cartItem.quantity}
                                onChange={(e) => { e.stopPropagation(); updateQuantity(medicine.medicine_id, parseInt(e.target.value) ); }}
                                onClick={(e) => e.stopPropagation()}
                                min="1" max={medicine.stock}
                                style={{ width: '50px', padding: '6px', textAlign: 'center', border: '1px solid #006d77', borderRadius: '4px', fontWeight: 'bold', fontSize: '14px' }}
                              />
                              <button onClick={(e) => { e.stopPropagation(); if (cartItem.quantity < medicine.stock) { updateQuantity(medicine.medicine_id, cartItem.quantity + 1); } else { notify(`Only ${medicine.stock} units available`, 'warning'); } }}
                                disabled={cartItem.quantity >= medicine.stock}
                                style={{ width: '32px', height: '32px', border: '1px solid #006d77', background: cartItem.quantity >= medicine.stock ? '#ccc' : 'white', borderRadius: '4px', cursor: cartItem.quantity >= medicine.stock ? 'not-allowed' : 'pointer', color: cartItem.quantity >= medicine.stock ? '#999' : '#006d77', fontWeight: 'bold', fontSize: '18px' }}>
                                +
                              </button>
                            </div>
                          ) : (
                            <button onClick={(e) => { e.stopPropagation(); addToCart(medicine); }}
                              style={{ width: '100%', padding: '10px', backgroundColor: '#006d77', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold', fontSize: '14px' }}>
                              + Add to Cart
                            </button>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : (
          /* ─── Order History Tab ─────────────────────────────────────────────── */
          <div style={{ backgroundColor: 'white', borderRadius: '8px', padding: '24px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
              <h2 style={{ margin: 0 }}>POS Order History</h2>
              <input type="date" value={selectedDate} onChange={(e) => setSelectedDate(e.target.value)}
                style={{ padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
              />
            </div>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ backgroundColor: '#f5f5f5' }}>
                  {['Order ID', 'Time', 'Customer', 'Items', 'Payment', 'Total', 'Status', 'Actions'].map(h => (
                    <th key={h} style={{ padding: '12px', textAlign: h === 'Items' || h === 'Status' || h === 'Actions' ? 'center' : h === 'Total' ? 'right' : 'left', borderBottom: '2px solid #ddd' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {orders.length === 0 ? (
                  <tr><td colSpan="8" style={{ padding: '48px', textAlign: 'center', color: '#999' }}>No POS orders found for this date</td></tr>
                ) : (
                  orders.map(order => (
                    <tr key={order.order_id} style={{ borderBottom: '1px solid #eee' }}>
                      <td style={{ padding: '12px' }}>{order.order_id}</td>
                      <td style={{ padding: '12px' }}>{formatISTTimestamp(order.created_at)}</td>
                      <td style={{ padding: '12px' }}>{order.delivery_address?.full_name || 'Walk-in'}</td>
                      <td style={{ padding: '12px', textAlign: 'center' }}>{order.items?.length || 0}</td>
                      <td style={{ padding: '12px' }}>
                        <span style={{ padding: '4px 8px', borderRadius: '4px', fontSize: '12px', backgroundColor: order.notes?.includes('UPI') ? '#e3f2fd' : '#f5f5f5', color: order.notes?.includes('UPI') ? '#1976d2' : '#666' }}>
                          {order.notes?.includes('UPI') ? 'UPI' : 'CASH'}
                        </span>
                      </td>
                      <td style={{ padding: '12px', textAlign: 'right' }}><strong>₹{order.total_amount?.toFixed(2)}</strong></td>
                      <td style={{ padding: '12px', textAlign: 'center' }}>
                        <span style={{ padding: '4px 8px', borderRadius: '4px', fontSize: '12px', backgroundColor: order.order_status === 'delivered' ? '#e8f5e9' : '#fff3e0', color: order.order_status === 'delivered' ? '#2e7d32' : '#e65100' }}>
                          {order.order_status}
                        </span>
                      </td>
                      <td style={{ padding: '12px', textAlign: 'center' }}>
                        <button onClick={() => viewOrderDetails(order)} style={{ padding: '10px 16px', margin:"10px", backgroundColor: '#006d77', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '15px' }}>
                          View
                        </button>
                        <button onClick={() => handleInvoiceDownload(order.order_id)} style={{ padding: '10px 16px', margin:"10px",backgroundColor: '#006d77', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '15px' }}>
                          Invoice
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* ─── Order Details Modal ─────────────────────────────────────────────── */}
      {showOrderDetails && selectedOrder && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '20px' }}>
          <div style={{ backgroundColor: 'white', borderRadius: '8px', padding: '24px', maxWidth: '800px', width: '100%', maxHeight: '90vh', overflow: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px', paddingBottom: '16px', borderBottom: '2px solid #e0e0e0' }}>
              <h2 style={{ margin: 0 }}>📋 Order Details</h2>
              <button onClick={() => setShowOrderDetails(false)} style={{ border: 'none', background: 'transparent', fontSize: '24px', cursor: 'pointer', color: '#999' }}>×</button>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '24px', padding: '16px', backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
              {[
                ['Order ID', selectedOrder.order_id],
                ['Date & Time', formatISTTimestamp(selectedOrder.created_at)],
                ['Customer Name', selectedOrder.delivery_address?.full_name || 'N/A'],
                ['Phone', selectedOrder.delivery_address?.phone || 'N/A'],
              ].map(([label, val]) => (
                <div key={label}>
                  <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>{label}</div>
                  <strong>{val}</strong>
                </div>
              ))}
            </div>

            <div style={{ marginBottom: '24px' }}>
              <h3 style={{ marginTop: 0, marginBottom: '16px' }}>Medicine Items</h3>
              <div style={{ border: '1px solid #e0e0e0', borderRadius: '8px', overflow: 'hidden' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr style={{ backgroundColor: '#f5f5f5' }}>
                      {['Medicine Name', 'Quantity', 'Unit Price', 'Total'].map(h => (
                        <th key={h} style={{ padding: '12px', textAlign: h === 'Quantity' ? 'center' : h === 'Unit Price' || h === 'Total' ? 'right' : 'left', borderBottom: '1px solid #e0e0e0' }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {selectedOrder.items && selectedOrder.items.length > 0 ? selectedOrder.items.map((item, index) => (
                      <tr key={index} style={{ borderBottom: '1px solid #f0f0f0' }}>
                        <td style={{ padding: '12px' }}>
                          <strong>{item.medicine_name || item.name || 'Unknown'}</strong>
                          {item.manufacturer && <div style={{ fontSize: '12px', color: '#666', marginTop: '2px' }}>{item.manufacturer}</div>}
                        </td>
                        <td style={{ padding: '12px', textAlign: 'center' }}>
                          <span style={{ padding: '4px 12px', backgroundColor: '#e3f2fd', borderRadius: '12px', fontSize: '14px', fontWeight: 'bold' }}>{item.quantity}</span>
                        </td>
                        <td style={{ padding: '12px', textAlign: 'right' }}>₹{(item.discounted_price || item.unit_price || item.price || 0).toFixed(2)}</td>
                        <td style={{ padding: '12px', textAlign: 'right' }}><strong>₹{((item.discounted_price || item.unit_price || item.price || 0) * item.quantity).toFixed(2)}</strong></td>
                      </tr>
                    )) : (
                      <tr><td colSpan="4" style={{ padding: '24px', textAlign: 'center', color: '#999' }}>No items found</td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            <div style={{ padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px', border: '1px solid #e0e0e0' }}>
              <h3 style={{ marginTop: 0, marginBottom: '16px' }}>Payment Summary</h3>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                <span>Subtotal:</span><strong>₹{(selectedOrder.subtotal || 0).toFixed(2)}</strong>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', color: '#d32f2f' }}>
                <span>Discount:</span><strong>-₹{(selectedOrder.discount || 0).toFixed(2)}</strong>
              </div>
              <hr style={{ margin: '12px 0', border: 'none', borderTop: '1px solid #ddd' }} />
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '20px', color: '#006d77' }}>
                <strong>Total Amount:</strong><strong>₹{(selectedOrder.total_amount || 0).toFixed(2)}</strong>
              </div>
            </div>

            {selectedOrder.notes && (
              <div style={{ marginTop: '24px', padding: '16px', backgroundColor: '#fff3e0', borderRadius: '8px', fontSize: '14px' }}>
                <strong style={{ display: 'block', marginBottom: '8px' }}>Notes:</strong>
                <div style={{ whiteSpace: 'pre-wrap', color: '#666' }}>{selectedOrder.notes}</div>
              </div>
            )}

            <div style={{ marginTop: '24px', display: 'flex', justifyContent: 'flex-end' }}>
              <button onClick={() => setShowOrderDetails(false)} style={{ padding: '12px 24px', backgroundColor: '#006d77', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ─── Payment Method Dialog ───────────────────────────────────────────── */}
      {showPaymentDialog && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ backgroundColor: 'white', borderRadius: '8px', padding: '24px', maxWidth: '500px', width: '90%' }}>
            <h2 style={{ marginTop: 0 }}>💳 Select Payment Method</h2>

            <div style={{ marginBottom: '24px' }}>
              {[['cash', '💵 Cash', 'Immediate payment'], ['upi', '📱 Online', 'Pay through UPI']].map(([val, label, sub]) => (
                <label key={val} style={{ display: 'block', padding: '16px', marginBottom: '12px', border: paymentMethod === val ? '2px solid #006d77' : '1px solid #ddd', borderRadius: '8px', cursor: 'pointer' }}>
                  <input type="radio" value={val} checked={paymentMethod === val} onChange={(e) => setPaymentMethod(e.target.value)} style={{ marginRight: '8px' }} />
                  <strong>{label}</strong>
                  <div style={{ fontSize: '12px', color: '#666', marginLeft: '24px' }}>{sub}</div>
                </label>
              ))}
            </div>

            {/* AYUJA price summary in dialog */}
            <div style={{ padding: '16px', backgroundColor: '#f5f5f5', borderRadius: '8px', marginBottom: '16px' }}>
              {hasAyuja && ayujaSavings > 0 && (
                <>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', color: '#9CA3AF', marginBottom: 4 }}>
                    <span>MRP Total:</span>
                    <span style={{ textDecoration: 'line-through' }}>₹{mrpSubtotal.toFixed(2)}</span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', color: '#16a34a', marginBottom: 4, fontWeight: 600 }}>
                    <span>🎯 AYUJA Discount ({ayujaDiscPct.toFixed(1)}% OFF):</span>
                    <span>-₹{ayujaSavings.toFixed(2)}</span>
                  </div>
                  {getDiscountAmount() > 0 && (
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', color: '#d32f2f', marginBottom: 4 }}>
                      <span>Additional Discount:</span>
                      <span>-₹{getDiscountAmount().toFixed(2)}</span>
                    </div>
                  )}
                  <hr style={{ border: 'none', borderTop: '1px solid #ddd', margin: '8px 0' }} />
                </>
              )}
              <strong style={{ fontSize: '24px' }}>Total: ₹{getTotal().toFixed(2)}</strong>
              {hasAyuja && ayujaSummary && (
                <div style={{ fontSize: '11px', color: '#6B7280', marginTop: 4 }}>
                  Alpha: {ayujaSummary.alpha} | Final discount: {ayujaSummary.final_discount_pct}%
                </div>
              )}
            </div>

            <div style={{ display: 'flex', gap: '12px' }}>
              <button onClick={() => setShowPaymentDialog(false)} style={{ flex: 1, padding: '12px', border: '1px solid #ddd', background: 'white', borderRadius: '8px', cursor: 'pointer' }}>Cancel</button>
              <button onClick={processOrder} disabled={loading} style={{ flex: 1, padding: '12px', border: 'none', background: loading ? '#ccc' : '#006d77', color: 'white', borderRadius: '8px', fontWeight: 'bold', cursor: loading ? 'not-allowed' : 'pointer' }}>
                {loading ? 'Processing...' : 'Confirm Payment'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ─── UPI Dialog ──────────────────────────────────────────────────────── */}
      {showUpiDialog && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ backgroundColor: 'white', borderRadius: '8px', padding: '24px', maxWidth: '500px', width: '90%' }}>
            <h2 style={{ marginTop: 0, display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ fontSize: '24px' }}>📱</span> UPI Payment
            </h2>
            <div style={{ textAlign: 'center', padding: '24px 0' }}>
            <div style={{ width: '250px', height: '250px', margin: '0 auto 24px', border: '2px solid #ddd', borderRadius: '8px', overflow: 'hidden' }}>
            <div style={{ width: '250px', height: '250px', margin: '0 auto 24px', 
                  border: '2px solid #ddd', borderRadius: '8px', overflow: 'hidden' }}>
                  {qrCodeUrl ? (
                    <img 
                      src={qrCodeUrl}
                      alt="UPI QR Code" 
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                    />
                  ) : (
                    // Loading placeholder while fetching
                    <div style={{ width: '100%', height: '100%', display: 'flex', 
                      alignItems: 'center', justifyContent: 'center', backgroundColor: '#f5f5f5', 
                      color: '#999', fontSize: '13px' }}>
                      Loading QR...
                    </div>
                  )}
                </div>
            </div>
            <div style={{ fontSize: '12px', color: '#999', marginBottom: '4px' }}>Scan to pay ₹{getTotal().toFixed(2)}</div>
            <div style={{ fontSize: '10px', color: '#999', marginBottom: '8px' }}>Order: {currentOrder?.order_id}</div>
              <h3 style={{ margin: '0 0 8px 0', fontSize: '24px', fontWeight: 'bold' }}>₹{getTotal().toFixed(2)}</h3>
              {currentOrder?.ayuja_savings > 0 && (
                <div style={{ fontSize: '13px', color: '#16a34a', fontWeight: 600, marginBottom: 12 }}>
                  🎯 Patient saved ₹{currentOrder.ayuja_savings.toFixed(2)} via AYUJA pricing
                </div>
              )}
              <div style={{ padding: '12px', backgroundColor: '#e3f2fd', borderRadius: '4px', marginBottom: '24px', textAlign: 'left', fontSize: '14px' }}>
                ℹ️ Customer should scan QR code and complete payment. Enter transaction ID after payment.
              </div>
              <input type="text" placeholder="Enter UPI Transaction ID" value={upiTransactionId}
                onChange={(e) => setUpiTransactionId(e.target.value)}
                style={{ width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '14px', marginBottom: '8px' }}
              />
              <div style={{ fontSize: '12px', color: '#666', textAlign: 'left' }}>Required after customer completes payment</div>
            </div>
            <div style={{ display: 'flex', gap: '12px' }}>
              <button onClick={() => { setShowUpiDialog(false); setUpiTransactionId(''); }} style={{ flex: 1, padding: '12px', border: '1px solid #ddd', background: 'white', borderRadius: '8px', cursor: 'pointer' }}>Cancel</button>
              <button onClick={completeUpiPayment} disabled={loading || !upiTransactionId.trim()}
                style={{ flex: 1, padding: '12px', border: 'none', background: (loading || !upiTransactionId.trim()) ? '#ccc' : '#006d77', color: 'white', borderRadius: '8px', fontWeight: 'bold', cursor: (loading || !upiTransactionId.trim()) ? 'not-allowed' : 'pointer' }}>
                {loading ? 'Processing...' : 'Confirm Payment'}
              </button>
            </div>
          </div>
        </div>
      )}
<Dialog 
        open={dialogOpen} 
        onClose={() => setDialogOpen(false)}
        PaperProps={{
          sx: { borderRadius: 3, minWidth: 300 }
        }}
      >
        <DialogContent sx={{ pt: 3 }}>
          <Typography sx={{ fontSize: 15 }}>{dialogMessage}</Typography>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button 
            onClick={() => setDialogOpen(false)}
            variant="contained"
            fullWidth
            sx={{
              bgcolor: '#006D77',
              textTransform: 'none',
              '&:hover': { bgcolor: '#004F55' }
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
      {/* ─── Notification Toast ───────────────────────────────────────────────── */}
      {notification && (
        <div style={{
          position: 'fixed', top: '20px', right: '20px', padding: '16px 24px',
          backgroundColor: notification.type === 'error' ? '#f44336' : notification.type === 'warning' ? '#ff9800' : notification.type === 'success' ? '#4caf50' : '#2196f3',
          color: 'white', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.2)', zIndex: 2000,
        }}>
          {notification.message}
        </div>
      )}
    </div>
  );
};

export default POSMedicineSystem;